import { IngredientUnitItem } from "./IngredientUnitItem";

export function IngredientUnitsList({ ingredientUnits, onDelete }) {
  return (
    <div className="flex flex-wrap gap-2">
      {ingredientUnits.map((unit) => (
        <IngredientUnitItem
          key={unit.unitId}
          ingredientUnit={unit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
